import React, { useCallback, useContext, useEffect, ReactNode } from "react";
import { DropdownMenu } from "../DropdownMenu";
import { IOperatorsProps } from "./OperatorsDropdownInterfaces";
import { HMIContext } from "../../contexts/HMIContext/HMIContext";
import { SelectChangeEvent } from "@mui/material/Select/Select";
import Box from "@mui/material/Box";
import { useStyles } from "./OperatorsDropdown.styles";
import { removeCurrentOperator } from "utilities/storageUtilities";

export const OperatorsDropdown = ({ operators, fullWidth }: IOperatorsProps) => {
    const { operator, handleOperator } = useContext(HMIContext);
    const classes = useStyles();

    useEffect(() => {
        if (operators.length < 1) {
            removeCurrentOperator();
            handleOperator(undefined);
        } else {
            const currentOperatorExists = operators.find(
                (currentOperator) => currentOperator.user.user_id === +operator!,
            );
            if (!currentOperatorExists) {
                removeCurrentOperator();
                handleOperator(undefined);
            }
        }
    }, [handleOperator, operators, operator]);

    const operatorOptions = operators.map((operator) => {
        return {
            id: `${operator.user.user_id}`,
            name: `${operator.user.first_name} ${operator.user.last_name}`,
            picture: operator.user.media?.media_url,
        };
    });

    const tKeys = {
        base: "operators_dropdown",
        title: "title",
        optionsHolder: "operator_options",
        placeholder: "select_operator",
        key: "option",
    };

    const handleChange = useCallback(
        (event: SelectChangeEvent<string>, child: ReactNode): void => {
            handleOperator(event?.target.value);
        },
        [handleOperator],
    );

    return (
        <Box className={classes.operatorsDropdownContainer}>
            <DropdownMenu
                dropdownValue={operator || ""}
                handleChange={handleChange}
                tKeys={tKeys}
                options={operatorOptions}
                withPicture={true}
                withSearchBar={true}
                fullWidth={fullWidth}
            />
        </Box>
    );
};
